import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllSalesTeams } from '@user/store/salesTeam'

import { useGetEligibleUsersForSalesTeams } from '@user/store/users/hooks/useGetEligibleUsersForSalesTeams'

export function useInitData(widgetData: any) {
  const salesTeams = useSelector(selectAllSalesTeams)

  const initSalesTeams = useMemo(() => {
    return widgetData.salesTeamIds
      ? salesTeams.filter((x) => widgetData.salesTeamIds.find((y) => x.id == y))
      : []
  }, [salesTeams, widgetData.salesTeamIds])

  const initSalesTeamsIds = useMemo(
    () => initSalesTeams.map((team) => team.id),
    [initSalesTeams],
  )

  const salesTeamsIds = useMemo(() => {
    const chosenSalesTeamsIds = salesTeams.map((salesTeam) => salesTeam.id)
    return initSalesTeamsIds.length ? initSalesTeamsIds : chosenSalesTeamsIds
  }, [salesTeams, initSalesTeamsIds])

  const { isFetching: loadingUsers } =
    useGetEligibleUsersForSalesTeams(salesTeamsIds)

  const initOwnersIds = useMemo(() => {
    if (widgetData.assigneeIds && !!widgetData.assigneeIds.length) {
      return widgetData.assigneeIds
    } else {
      return []
    }
  }, [widgetData.assigneeIds])

  const initNumDays = widgetData.numberOfDays || 7

  return {
    initOwnersIds,
    initSalesTeams,
    initSalesTeamsIds,
    initNumDays,
    loadingUsers,
  }
}
